export default __webpack_public_path__ + "static/media/Group8557.0d4295c1.svg";